export default __webpack_public_path__ + "static/media/akar-arrow-right.338cdf28.svg";